module.exports = __webpack_public_path__ + "assets/img/102008.091edc7a.png";